import { CircleHelp } from 'lucide-react';

const FieldHelpButton = ({ onClick, active = false, label = 'What does this mean?' }) => (
  <button
    type="button"
    className={`lk-conv-field-help${active ? ' lk-conv-field-help--active' : ''}`}
    aria-label={label}
    aria-pressed={active}
    onClick={onClick}
  >
    <CircleHelp size={15} strokeWidth={2} aria-hidden />
  </button>
);

export default FieldHelpButton;
